import { createHashHistory } from 'history'
import * as React from 'react'
import { Provider } from 'react-redux'
import { createGlobalStyle } from 'styled-components'
import { ConnectedRouter } from 'connected-react-router'
import { configureStore } from 'store/configureStore'
import { ThemeProvider } from 'styled-components'

import Routes from './Routes'
import defaultTheme from './style/defaultTheme'

export const history = createHashHistory()

export const store = configureStore()

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gotham SSm A', 'Gotham SSm B';
    font-weight: 600;
    font-style: normal;
  }

/*CSS Reset */
* {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
    font-size: 1em;
  }

  html {
    font-family: "Gotham SSm A", "Gotham SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    overflow-x:hidden;
  }
`

const App = ({}): JSX.Element => (
  <div>
    <GlobalStyles/>
    <ThemeProvider theme={defaultTheme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <main>
              <Routes />
            </main>
          </div>
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.tsx